import { useEffect } from 'react'

import { makeVar } from '@apollo/client'

import { CreateReceiptOutput } from '@web/gql/graphql'
import { ReceiptErrorMessage } from '@web/pages/receipt/components/Scanning/hooks/helper'

export enum ReceiptFileStatus {
  SCANNING = 'scanning',
  SCAN_FAILED = 'failed',
  DUPLICATED = 'duplicated',
  REWARDED = 'rewarded',
  CHECKED_IN = 'checkedIn',
}

export const RECEIPT_FILE_STATUS_KEY = 'status'
export const receiptFileVar = makeVar<File | undefined>(undefined)
export const receiptMessageVar = makeVar<ReceiptErrorMessage | undefined>(undefined)
export const receiptVar = makeVar<CreateReceiptOutput | undefined>(undefined)

export const useUploadReceiptCleanUp = () => {
  useEffect(
    () => () => {
      receiptFileVar(undefined)
      receiptMessageVar(undefined)
    },
    [],
  )
}
